import GmailIcon from '../../../../assets/google-apps/gmail.png';
import DriveIcon from '../../../../assets/subscriptions/drive.png';
import Box from '@mui/material/Box';

export type LabelApp = 'DRIVE' | 'GMAIL';

const APP_ICONS: Record<LabelApp, { src: string; alt: string }> = {
  DRIVE: { src: DriveIcon, alt: 'Drive and Docs' },
  GMAIL: { src: GmailIcon, alt: 'Gmail' },
};

export default function LabelAppIcon({
  app,
  size = 16,
}: {
  app: LabelApp;
  size?: number;
}) {
  return (
    <Box
      component="img"
      src={APP_ICONS[app].src}
      alt={APP_ICONS[app].alt}
      sx={{ width: size, height: size, objectFit: 'contain', flexShrink: 0 }}
    />
  );
}
